<template>
<div class="chapter">
<div class="inner_page">
<p class="P_Normal__And__Centre_Alignment" id="auto_bookmark_toc_2"><span>Love Means… No Boundaries</span></p>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
<p class="P_Normal">by Andrew Grey</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Joey Sutherland has found a home with Geoff Laughton and his partner, Eli, living and working at the farm that has become a refuge after a motorcycle accident left him with a scarred face and a lot of insecurities. When Geoff’s aunt Mari convinces them to take in a musician from the National Youth Symphony, Joey is reluctantly roped into picking him up, already anticipating the disgust he’ll see on the man’s face.</p>
<p class="P_Normal"> </p>
<p class="P_Normal">But Robert Edward Jameson surprises him: he’s outgoing and friendly, he’s willing to try just about anything around the farm, and he’s blind, which goes a long way toward easing Joey’s nerves.</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Joey and Robbie become inseparable and discover the beginnings of love. But summer is coming to an end, and Robbie will return to his home in Mississippi, where his family and servants see to everything he could want or need. Joey can only hope Robbie will take a chance on love and escape the boundaries that have shaped his sightless life.</p>
<p class="P_Normal"> </p>
<p class="P_Normal"> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section-0002.vue?a0788b06